// extracted by mini-css-extract-plugin
export default {"submenu":"SubMenuItem_submenu__8l4uG","active":"SubMenuItem_active__hwutP","loading-text":"SubMenuItem_loading-text__yr-Vd","submenu-item":"SubMenuItem_submenu-item__w6Q-k"};